import { DOCUMENT_PARTY_LABEL, type DocumentParty } from '@/lib/api/documents';
import { cn } from '@/lib/utils/cn';

/**
 * Whose document it is, as a plain chip: Vendor / Avero / Client (E19 /
 * T-0215, design §4). Ink tones from the theme — it is a fact about the
 * document, not an AI surface and not a provenance marker — on every
 * document card and on the document detail.
 */
export function PartyChip({ party, className }: { party: DocumentParty; className?: string }) {
  const label = DOCUMENT_PARTY_LABEL[party];
  return (
    <span
      data-party={party}
      title={`${label} document`}
      className={cn(
        'inline-flex h-[22px] flex-none items-center whitespace-nowrap rounded-full bg-ink-100 px-2.5 text-[12px] font-medium leading-[18px] text-ink-700',
        className,
      )}
    >
      {label}
    </span>
  );
}
